export default __webpack_public_path__ + "static/tax-planning-456bd5b0b637e82435d5ce936896011b.jpeg";